import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentViewerComponent } from './components/document-viewer/document-viewer.component';
import { DocumentsListComponent } from './components/documents-list/documents-list.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonsModule } from '../common/commons.module';
import { DocumentUploaderModalComponent } from './components/document-uploader-modal/document-uploader-modal.component';
import { DocumentUploaderComponent } from './components/document-uploader/document-uploader.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { DocumentTypeEditorComponent } from './components/document-type-editor/document-type-editor.component';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { FileUploadModule } from 'primeng/fileupload';

@NgModule({
  declarations: [
    DocumentViewerComponent,
    DocumentsListComponent,
    DocumentUploaderModalComponent,
    DocumentUploaderComponent,
    DocumentTypeEditorComponent,
  ],

  imports: [
    CommonModule,
    FontAwesomeModule,
    TableModule,
    InputTextModule,
    CommonsModule,
    FormsModule,
    SharedModule,
    FileUploadModule
  ],

  providers: [],

  exports: [DocumentViewerComponent, DocumentsListComponent, DocumentUploaderComponent]
})

export class DocumentsModule { }
